import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { AdminService } from '@offconon/admin-api';
import { FormErrorsComponent } from '@offconon/shared/ui/form-elements/form-errors';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'offconon-admin-login',
  templateUrl: './login.component.html',
  imports: [
    CardModule,
    FormsModule,
    ReactiveFormsModule,
    FormErrorsComponent,
    PasswordModule,
    ButtonModule,
    TranslateModule,
    InputTextModule,
  ],
})
export class LoginComponent implements OnInit {
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authenticationService = inject(AuthService);
  private adminService = inject(AdminService);

  private destroyRef = inject(DestroyRef);

  loading = false;
  returnUrl: string;

  form = inject(FormBuilder).group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });

  ngOnInit() {
    this.returnUrl = '/dashboard';
  }

  login() {
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.adminService
      .adminLoginCreate(this.form.value as any)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (user: any) => {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('Successful'),
            detail: this.translate.instant('You have successfully logged in.'),
          });
          this.authenticationService.login(user);
          this.router.navigate([this.returnUrl]);
          this.loading = false;
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            for (const key in err.error.errors) {
              this.messageService.add({
                severity: 'error',
                summary: this.translate.instant('Something went wrong. Please try again.'),
                detail: this.translate.instant('' + err.error.errors[key].error),
              });
            }
          } else {
          }
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  createResetPassword() {
    this.router.navigate(['/reset-password']);
  }
}
